import React, { useEffect, useState, useRef } from 'react'
import { Row, Col } from 'react-bootstrap'
import {
  Header,
  Footer,
  Loading,
  Search_Box1,
  Paginate,
} from '../../components/index'
import { WebApi } from '../../api/web'
import { UploadsUrl } from '../../services/url'
import { debounce } from 'lodash'
const Library = () => {
  const [libraryData, setLibraryData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [valueSearch, setValueSearch] = useState('')
  const [totalPage, setTotalPage] = useState(1)
  const [page, setPage] = useState(1)

  useEffect(() => {
    Library()
  }, [page])

  const Library = async () => {
    setLoading(true)
    await WebApi.library(page, valueSearch.trim())
      .then((res) => {
        setLoading(false)
        setLibraryData(res.data.data.libraries.libraries)
        setTotalPage(res.data.data.libraries.totalPages)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  const SearchLibrary = (value) => {
    setValueSearch(value)
    setLoading(true)
    WebApi.library(page, value.trim())
      .then((res) => {
        setLoading(false)
        setLibraryData(res.data.data.libraries.libraries)
        setTotalPage(res.data.data.libraries.totalPages)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  const throttled = useRef(debounce(SearchLibrary, 1500))
  return (
    <>
      <Header title='کتابخانه دکتر وکیل' />
      {loading && <Loading />}
      <div className='container'>
        <div className='template-pages'>
          <div className='library'>
            <Search_Box1
              placeholder='نام کتاب، مقاله یا نویسنده را یادداشت کنید...'
              setState={throttled.current}
            />

            <div className='m-t-40'>
              {libraryData ? (
                libraryData.map((book) => (
                  <div className='book-cover'>
                    <Row className='align-items-center'>
                      <Col
                        xs={4}
                        sm={3}
                        className='d-flex justify-content-center'
                      >
                        <img src={`${UploadsUrl}/${book.image}`} alt='book' />
                      </Col>
                      <Col xs={8} sm={9} className='pr-0'>
                        <div className='detail'>
                          <h5>{book.title}</h5>
                          <span>نویسنده : {book.author}</span>
                          <span>{book.titleContent}</span>
                          <a href={`/book/${book._id}`}>دریافت و مشاهده</a>
                        </div>
                      </Col>
                    </Row>
                  </div>
                ))
              ) : (
                <Loading />
              )}
              <Paginate {...{ totalPage, page, setPage }} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
export default Library
